import { httpGet } from '@inner-source/cis-shared/transports';

const getApplicantsByIssueApi = async ({ issueId }) => httpGet('/get-applicants-by-issue', { issueId });

export default getApplicantsByIssueApi;
